import { selectCurrentHotelId, selectCurrentHotelName } from 'accessors'
import { useSelector } from 'react-redux'
import { fetcher } from 'services/helpers/responseHandler'
import LocalUserService from 'services/localUserService'

function useLogzIo() {
  const userService = new LocalUserService()
  const currentUserInfo = userService.getCurrentUserInfo()

  const uiSubsidiaryName = useSelector(selectCurrentHotelName)
  const uiSubsidiaryId = useSelector(selectCurrentHotelId)
  const uiDashboardSessionId = currentUserInfo?.sessionId
  const uiUserName = currentUserInfo?.user?.name
  const uiPath = document.location.pathname
  const uiScreenResolution = `${window.screen.width}x${window.screen.height}`

  const uiIsInternalAdmin = useSelector(s => s.login.actuallyIsInternalAdmin)

  const log = async ({
    level = 'Info', // Error, Fatal, Debug, Info, Warn
    message = '',
    additionalData = {}
  }) => {
    try {
      // Check if user is logged in before trying to log
      if (!uiDashboardSessionId) {
        return // Silently fail if not logged in - don't break the app
      }
      
      fetcher.post('logs', {
        level,
        message,
        additionalData: {
          uiSubsidiaryName,
          uiSubsidiaryId,
          uiDashboardSessionId,
          uiUserName,
          uiPath,
          uiScreenResolution,
          uiIsInternalAdmin,
          ...additionalData
        }
      })
    } catch (error) {
      // Silently fail - logging errors shouldn't break the app
      // Only log to console in development
      if (process.env.NODE_ENV === 'development') {
        console.warn('failed to post log', error)
      }
    }
  }

  return log
}

export default useLogzIo
